import { DashboardPreference } from './dashboard-preference';
import { AppWidgetState } from '../widgets/app-widget-state';

export interface Dashboard {
    id: number | undefined;
    name: string;
    description: string;
    abbreviation: string;
    isGlobal: boolean;
    clientCode: string | undefined;
    createdBy: string;
    createdDate: string;
    updatedDate: string;
    privilege: 'EDIT' | 'VIEW';
    allowInfiniteVScroll: boolean;
    allowInfiniteHScroll: boolean;
    dashboardPreference: DashboardPreference;
    widgets?: AppWidgetState[];
    version?: number;
    dashboardPreferences?: DashboardPreference[]; // drop this after the migration
}

export class DashboardModel implements Dashboard {
    id: number;
    name: string;
    description: string;
    abbreviation: string;
    isGlobal: boolean;
    clientCode: string | undefined;
    privilege: 'EDIT' | 'VIEW';
    createdBy: string;
    createdDate: string;
    updatedDate: string;
    allowInfiniteVScroll: boolean;
    allowInfiniteHScroll: boolean;
    widgets: AppWidgetState[];
    dashboardPreferences: DashboardPreference[]; // drop this after the migration
    dashboardPreference: DashboardPreference;
    version = Number.MIN_VALUE;

    // eslint-disable-next-line complexity
    constructor(init: Partial<Dashboard>) {
        this.id = init?.id ?? 0;
        this.name = init?.name ?? '';
        this.description = init?.description ?? '';
        this.abbreviation = init?.abbreviation ?? '';
        this.isGlobal = !!init?.isGlobal;
        this.clientCode = init?.clientCode;
        this.allowInfiniteVScroll = !!init?.allowInfiniteVScroll;
        this.allowInfiniteHScroll = !!init?.allowInfiniteHScroll;
        this.privilege = init?.privilege ?? 'VIEW';
        this.createdBy = init?.createdBy ?? '';
        this.createdDate = init?.createdDate ?? '';
        this.updatedDate = init?.updatedDate ?? '';

        this.dashboardPreference = getDashboardPreference(init);
        this.dashboardPreferences = init?.dashboardPreferences ?? [];
        this.version = init.version ?? Number.MIN_VALUE;

        this.widgets = init.widgets ?
            init.widgets.map((widget) => new AppWidgetState(widget)) :
            [];
    }

    cloneForCopy(): DashboardModel {
        const clone = new DashboardModel(this);
        clone.isGlobal = false;
        clone.name += ' copy';
        return clone;
    }
}

function getDashboardPreference(dashboardModel: Partial<DashboardModel>): DashboardPreference {
    if (dashboardModel.dashboardPreference) {
        return dashboardModel.dashboardPreference;
    }
    if (dashboardModel.dashboardPreferences && dashboardModel.dashboardPreferences.length > 0) {
        return dashboardModel.dashboardPreferences[0];
    }
    return {};
}
